var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInitLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5314_289250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 46,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3633 5.5H30.6367V16.0469H25.3633V5.5ZM21.4125 17.6837L17.6837 21.4124L10.2261 13.9548L13.9548 10.226L21.4125 17.6837ZM16.0469 25.3633H5.5V30.6367H16.0469V25.3633ZM21.4123 38.316L13.9547 45.7737L10.2259 42.0449L17.6836 34.5872L21.4123 38.316ZM30.6367 39.9531H25.3633V50.5H30.6367V39.9531ZM45.7735 42.0451L42.0447 45.7739L34.5871 38.3163L38.3159 34.5875L45.7735 42.0451ZM50.5 25.3633H39.9531V30.6367H50.5V25.3633Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5314_289250",
    x1: 28,
    y1: 5.5,
    x2: 28,
    y2: 50.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB40FE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInitLoader);
export default __webpack_public_path__ + "static/media/init-loader.e9cc7fb8.svg";
export { ForwardRef as ReactComponent };